import { createReactComponent } from '@tabler/icons-react';

export const IconCustomRowBelow = createReactComponent(
  'outline',
  'customRowBelow',
  'CustomRowBelow',
  [
    [
      'path',
      {
        key: 'customRowBelow-path-1',
        d: 'M12,16v6.4M8.8,19.2h6.4',
      },
    ],
    [
      'path',
      {
        key: 'customRowBelow-path-2',
        d: 'M19.4,11.7H4.6c-.6,0-1.1-.5-1.1-1.1v-6.3c0-.6.5-1.1,1.1-1.1h14.8c.6,0,1.1.5,1.1,1.1v6.3c0,.6-.5,1.1-1.1,1.1ZM20.5,7.4H3.5',
      },
    ],
  ]
);
